import { OpenInsuranceSelectorEvent } from "../../js/insurance-selector-events.87d20ca02104.js";
import { MOBILE_SCREEN_QUERY } from "../../js/shared.0f27bac2f95c.js";

const bindSearchWidgets = () => {
  const handleServiceTabClick = (e) => {
    const hiddenServiceTypeFilterInput = document.getElementById("hidden-only");
    hiddenServiceTypeFilterInput.value = e.target.dataset.tabValue;
    hiddenServiceTypeFilterInput.dispatchEvent(
      new Event("change", { bubbles: true }),
    );
  };
  const tabButtons = document.querySelectorAll("button[data-tab-value]");
  tabButtons.forEach((button) => {
    button.addEventListener("click", handleServiceTabClick);
  });

  const handleSearchBarInsuranceChange = (e) => {
    const hiddenNetworkInput = document.getElementById("hidden-network");
    hiddenNetworkInput.value = e.detail.networkConfig.value;
    hiddenNetworkInput.dispatchEvent(new Event("change", { bubbles: true }));
    document.querySelector("[data-mobile-toggle-insurance]").textContent =
      e.detail.networkConfig.label;
  };
  document.addEventListener(
    "tqc:pet-insurance-changed",
    handleSearchBarInsuranceChange,
  );

  const handleSearchBarLocationChange = (e) => {
    const hiddenLocationInput = document.getElementById("hidden-location");
    hiddenLocationInput.value = e.detail.providerId;
    hiddenLocationInput.dispatchEvent(new Event("change", { bubbles: true }));
    document.querySelector("[data-mobile-toggle-location]").textContent =
      e.detail.label;
  };
  document.addEventListener(
    "tqc:pet-location-changed",
    handleSearchBarLocationChange,
  );

  const searchBar = document.querySelector(".search-bar--popover");
  const openMobileSearchOverlay = () => {
    searchBar.classList.remove("pv-hide-on-small");
    searchBar.classList.add("pv-inset-square-16");
  };

  const closeMobileSearchOverlay = () => {
    searchBar.classList.add("pv-hide-on-small");
    searchBar.classList.remove("pv-inset-square-16");
  };
  const mobileSearchToggle = document.getElementById("open-mobile-search");
  mobileSearchToggle.addEventListener("click", openMobileSearchOverlay);

  const mobileSearchCloseButtons = document.querySelectorAll(
    ".search-bar--popover .mobile-close",
  );
  mobileSearchCloseButtons.forEach((button) => {
    button.addEventListener("click", closeMobileSearchOverlay);
  });

  const handleClickInsuranceCta = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (MOBILE_SCREEN_QUERY.matches) {
      openMobileSearchOverlay();
    } else {
      document.dispatchEvent(new OpenInsuranceSelectorEvent(true));
    }
  };
  const checkCoverageLinks = document.querySelectorAll(".tqc-check-coverage");
  checkCoverageLinks.forEach((link) => {
    link.addEventListener("click", handleClickInsuranceCta);
  });
};
bindSearchWidgets();
document.addEventListener("htmx:afterSettle", () => {
  bindSearchWidgets();
});
